import { useState, useEffect } from 'react';

export const useAppVersion = () => {
  const [versionData, setVersionData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const versionLink = document.querySelector('link[rel="version"]');

    if (!versionLink) {
      setIsLoading(false);
      return;
    }

    const versionUrl = versionLink.getAttribute('href');
    if (!versionUrl) return

    fetch(versionUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch version file: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setVersionData(data?.version);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err.message || 'An error occurred while fetching the version.');
        setIsLoading(false);
      });
  }, []);
  return { versionData, isLoading, error };
};